module.exports = "<p>\n  text-input works!\n</p>\n"